import src from "IMAGE";
export default { src, width: 167, height: 51, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAax3P9Aw+T/c9Pr/zfA4/9FxeX/PcLk/yu94f8Jstz/AAax3P9HxeX/ctPr/zjB4/89wuT/OsHj/y294v8Jstz/yx8tXG71/TIAAAAASUVORK5CYII="};
